import React, { useState } from 'react';
import type {
  EmbedCategory,
  EmbeddedScriptPlacement,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { useProjectModel } from '../../../model.js';
import { generateEmbeddedScript } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import {
  ChooseScriptFolderStep,
  ChooseScriptNameStep,
  ChooseScriptPlacementStep,
  ChooseScriptTypeStep,
} from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateEmbeddedScript = () => {
  const { model } = useProjectModel();

  const [scriptFolder, setScriptFolder] = useState<string>();
  const [scriptName, setScriptName] = useState<string>();
  const [scriptType, setScriptType] = useState<EmbedCategory>();
  const [scriptPlacement, setScriptPlacement] =
    useState<EmbeddedScriptPlacement>();

  const scriptQuestionsAnswered =
    scriptFolder && scriptName && scriptType && scriptPlacement;

  const generationTask = useGenerationTask(async () => {
    if (!scriptQuestionsAnswered) {
      return;
    }

    return generateEmbeddedScript(
      model.projectFolder,
      scriptFolder,
      scriptName,
      scriptType,
      scriptPlacement
    );
  }, [scriptQuestionsAnswered]);

  return [
    <ChooseScriptNameStep onSubmit={setScriptName} scriptName={scriptName} />,
    <ChooseScriptFolderStep
      onSubmit={setScriptFolder}
      scriptName={scriptName}
      scriptFolder={scriptFolder}
    />,
    <ChooseScriptTypeStep onSubmit={setScriptType} />,
    <ChooseScriptPlacementStep onSubmit={setScriptPlacement} />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'embedded script'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/about-embedded-scripts
        learnMoreUrl: 'https://wix.to/AjDt9qT',
      })}
    />,
  ];
};
